import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Statistic } from 'antd';
import styles from './overdue-totals.module.scss';
import type { IOverdueTotalsProps } from './types';

export const OverdueTotals: React.FC<IOverdueTotalsProps> = (props) => {
  const { totals } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Card>
        <Statistic title={t('overdue:overdue_percentage')} value={totals.percent} suffix='%' precision={1} />
      </Card>
      <Card>
        <Statistic title={t('overdue:total_count')} value={totals.totalCount} />
      </Card>
      <Card>
        <Statistic title={t('overdue:overdue_count')} value={totals.completedOverdueCount} />
      </Card>
      <Card>
        <Statistic title={t('common:not_completed')} value={totals.notCompletedCount} />
      </Card>
    </div>
  );
};
